import { useState } from "react";
import { fetchPatientBills } from "../../utils/patients/fetchPatientsBills";
import useProfileStore from "../../store/patient/profileStore";
import { fetchPatientBillsAlt } from "../../utils/patients/fetchPatientBillsAlt";
import { fetchPatientPendingBills } from "../../utils/patients/findpatientpendingBills";
import { generatePaymentUrl } from "../../utils/patients/generatePaymentUrl";

const useManageBills = () => {

  const [loading, setLoading] = useState(false);
  const [userBills, setUserBills ] = useState();
  const {profile} = useProfileStore()
  const [recurring, setrecurring] = useState();
  const [paymentData, setPaymentData] = useState();

  

  // id = 27503
  const findPatientBills = async () => {
    try{
      setLoading(true);
      const response = await fetchPatientBills(profile?.id)
      
      setUserBills(response.data);
      console.log(response.data)
      setLoading(false);

    } catch(err) {
      console.log(err)
      setLoading(false)
      window.location.href = "/pages/signin2";
      console.log("error error");
    }
    
  };

  const findPatientPendingBills = async () => {
    try{
      setLoading(true);
      const response = await fetchPatientPendingBills(profile?.id)
      
      setUserBills(response.data);
      setrecurring(response.data)
      console.log(response.data)
      setLoading(false);

    } catch(err) {
      console.log(err)
      setLoading(false)
      window.location.href = "/pages/signin2";
      console.log("error error");
    }
    
  };


  const generatePayment = async (data) => {
    try{
      setLoading(true);
      const response = await generatePaymentUrl(data)
      
     setPaymentData(response.data);
      console.log(response.data)
      setLoading(false);

    } catch(err) {
      console.log(err)
      setLoading(false)
      // window.location.href = "/pages/signin2";
      console.log("error error");
    }
    
  };


  const findPatientBillsAlt = async () => {
    try{
      setLoading(true);
      const response = await fetchPatientBillsAlt(profile?.id)
      
      setUserBills(response.data);
      setrecurring(response.data)
      console.log(response.data)
      setLoading(false);

    } catch(err) {
      console.log(err)
      setLoading(false)
      window.location.href = "/pages/signin2";
      console.log("error error");
    }
    
  };



  return {
    findPatientBills,
    findPatientBillsAlt,
    loading,
    recurring,
    findPatientPendingBills,
    userBills,
    generatePayment,
    paymentData
  };
};

export default useManageBills;